/**
 * Player Marker Definitions
 * 
 * Defines the available player marker options for character selection
 */

export interface PlayerMarker {
  id: string;
  name: string;
  image: string;
  gender: 'male' | 'female';
}

export const PLAYER_MARKERS: PlayerMarker[] = [
  { id: 'male_1', name: 'Male 1', image: '/assets/monsters/male_1.png', gender: 'male' },
  { id: 'male_2', name: 'Male 2', image: '/assets/monsters/male_2.png', gender: 'male' },
  { id: 'male_3', name: 'Male 3', image: '/assets/monsters/male_3.png', gender: 'male' },
  { id: 'male_4', name: 'Male 4', image: '/assets/monsters/male_4.png', gender: 'male' },
  { id: 'female_1', name: 'Female 1', image: '/assets/monsters/female_1.png', gender: 'female' },
  { id: 'female_2', name: 'Female 2', image: '/assets/monsters/female_2.png', gender: 'female' },
  { id: 'female_3', name: 'Female 3', image: '/assets/monsters/female_3.png', gender: 'female' },
  { id: 'female_4', name: 'Female 4', image: '/assets/monsters/female_4.png', gender: 'female' },
];

export const DEFAULT_MARKER = 'male_1';

/**
 * Get marker image path by ID
 */
export function getMarkerImage(markerId: string | undefined): string {
  if (!markerId) {
    return '/assets/monsters/player-marker.png'; // Legacy default
  }
  
  const marker = PLAYER_MARKERS.find(m => m.id === markerId);
  return marker ? marker.image : '/assets/monsters/player-marker.png';
}

